import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";

import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { $crud } from "../utils/CrudFactory";
import axios from "axios";
import { API_URL } from "../constants";
import { useAdmin } from "../components/AdminProvider";

const ProtectedRoute = () => {
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { adminData, setAdminData } = useAdmin();

  const useAuth = () => {
    const user = localStorage.getItem("token");
    // if (user) {
    //   return true;
    // } else {
    //   return false;
    // }
    return true;
  };

  const auth = useAuth();

  useEffect(() => {
    if (adminData.data !== null) {
      setLoading(false);
      return;
    }
    async function checkAuth() {
      try {
        const { data } = await axios.post(
          `${API_URL}create/admin/checkAuth`,
          {},
          { withCredentials: true }
        );

        if (!data.data.auth) {
          // localStorage.clear();
          navigate("/login", {
            state: { message: "Please Login!" },
          });
          return;
        }

        setAdminData((adminData) => ({ ...adminData, data: data.data.admin }));
      } catch (e) {
        // localStorage.clear();
        navigate("/login", {
          state: { message: "Please Login!" },
        });
      } finally {
        setLoading(false);
      }
    }
    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <Box
        display={"flex"}
        height={"100vh"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  if (adminData.data !== null) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
    // return <Navigate to="/login-page" />;
  }
};
export default ProtectedRoute;
